import styles from './spinner.module.css';
import React from 'react';

const Spinner = () => {
  return <span className={styles.spinner}></span>;
};

export default Spinner;
